import { createStore } from "vuex";
import instance from './axiosInterceptor.js';

const store = createStore({
    state(){
        return {
            loginId : '',      
            isLogin : false,
        }        
    },
    mutations:{
        loginSuccess(state){
            state.isLogin = true;            
        },
        loginFail(state){
            state.isLogin = false;
        },
        logout(state){
            state.isLogin = false;
            state.loginId = '';
        },
        setLoginId(state, payload){
            state.loginId = payload;
        },
    },
    actions:{
        /**
         * 로그인 상태 확인 (앱 초기 진입 시 호출)
         * - accessToken 이 있으면 /api/loginCheck 로 검증
         * - 유효하면 loginSuccess, userId 세팅
         * - 401 이면 /auth/refresh-token 으로 accessToken 재발급 시도
         * - 그 외 실패 시 조용히 로그아웃 처리 (alert 제거)
         *
         * [FIX] alert 제거: 네트워크 오류, 토큰 만료 시 alert 대신 console.warn 처리
         *   - 앱 로드 시 alert 가 뜨는 것은 UX 상 매우 불쾌
         *   - 로그인 페이지 리다이렉트로 충분
         */
        async loginCheck({commit, state}) {
            const data = { userId: state.loginId };
            const at = localStorage.getItem('accessToken');

            if (!at) return "FAIL";

            let retStr = "FAIL";

            try {
                const response = await instance.post(
                    process.env.VUE_APP_API_SERVER_URL + '/api/loginCheck',
                    data
                );

                if (response.status === 200 && response.data.retSuccessFail === "SUCCESS") {
                    commit('loginSuccess');
                    commit('setLoginId', response.data.retObj.userId);
                    retStr = response.data;

                } else if (response.status === 401) {
                    // accessToken 만료 → refreshToken 으로 재발급 시도
                    try {
                        const refreshToken = localStorage.getItem('refreshToken');
                        const refreshRes = await instance.post(
                            process.env.VUE_APP_API_SERVER_URL + '/auth/refresh-token',
                            {},
                            { headers: { Authorization: `Bearer ${refreshToken}` } }
                        );
                        if (refreshRes.status === 200 && refreshRes.data.retSuccessFail === "SUCCESS") {
                            localStorage.setItem('accessToken', refreshRes.data.retObj.accessToken);
                            commit('loginSuccess');
                        } else {
                            commit('loginFail');
                        }
                    } catch (e) {
                        console.warn('refresh-token failed:', e);
                        commit('loginFail');
                    }

                } else {
                    // [FIX] alert 제거 → 조용히 실패 처리
                    commit('loginFail');
                }

            } catch (error) {
                // [FIX] alert(error) 제거 → console.warn 으로 대체
                console.warn('loginCheck error:', error);
                commit('loginFail');
            }

            return retStr;
        },
    },
});

export default store
